export const actions = { 
  CLEAR_DATA: 'CLEAR_DATA',
  SELECT_COMPANY: 'SELECT_COMPANY'
}

export const dispatchToProps = (dispatch) => ({
  clearData: () => { dispatch({ type: actions.CLEAR_DATA }) }
})
